import React, { useEffect } from "react";
import { FylloHeader, FylloViewFertigationReport } from "react-library";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../services/locale.service";
import { TBackEvent } from "../../types";
import { Routes } from "../../routes";
import NutrientReportService from "../../services/nutrientReport.service";

const ViewFertigationReport = () => {
  const { state } = useLocation();
  const { plotId } = useParams();
  const navigate = useNavigate();

  const headerTitle = t("fertigation") + " " + t("Report");

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    window.addEventListener("fylloButtonClicked", handleIconButtonClick);
    return () => {
      window.addEventListener("back-icon-press", handleBack);
      window.addEventListener("fylloButtonClicked", handleIconButtonClick);
    };
  }, []);

  const handleBack = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if(eventKey === headerTitle) {
      navigate(Routes.fertigationHistory.replace(":plotId", plotId!));
    }
  };

  const handleIconButtonClick = async (e: Event) => {
    const { detail } = e as Event & { detail: { id: string, name: string } };
    const {id } = detail;
    if(id === "fyllo-fertigation-rewrite-button") {
      navigate(Routes.createfertigation.replace(":plotId", plotId!), { state: { report: state.report } });
    } else if (id === "fyllo-fertigation-delete-button") {
      const reportId = state.report.id;
      await NutrientReportService.deleteNutrientReport(reportId);
      navigate(Routes.fertigation.replace(":plotId", plotId!));
    }
  };

  return (
    <div>
      <FylloHeader headerTitle={headerTitle} hasBackIcon />
      {
        Boolean(state.report) && Object.keys(state.report).length > 0 && <FylloViewFertigationReport 
          ferticationReport={state.report}
        />
      }
    </div>
  );
};

export default ViewFertigationReport;